import EmblaCarousel from 'embla-carousel';
// plugins
import AutoHeight from 'embla-carousel-auto-height';
import Fade from 'embla-carousel-fade';
// utils
import { initEmblaDots } from '../utils/embla-utils';

const imageSliders = document.querySelectorAll('.paragraph-image-slider');

const initSlider = (slider) => {
  const emblaNode = slider.querySelector('.embla .embla__viewport');
  const embla = EmblaCarousel(emblaNode, { loop: true, watchDrag: false }, [
    AutoHeight(),
    Fade(),
  ]);

  // Hide arrows/dots if there's nothing to slide.
  const canPrev = embla.canScrollPrev();
  const canNext = embla.canScrollNext();

  if (!canPrev && !canNext) {
    slider.classList.add('embla--hide-controls');
  }

  // Attach event listeners to arrow buttons.
  const prevButton = slider.querySelector('.embla__button--prev');
  const nextButton = slider.querySelector('.embla__button--next');

  prevButton.addEventListener('click', embla.scrollPrev, false);
  nextButton.addEventListener('click', embla.scrollNext, false);

  // Build and attach event listeners to dots navigation.
  const dotsNode = slider.querySelector('.embla__dots');
  initEmblaDots(embla, dotsNode);
};

(() => {
  if (imageSliders.length > 0) {
    imageSliders.forEach((slider) => {
      initSlider(slider);
    });
  }
})();
